import { jsx as b } from "react/jsx-runtime";
import { useMemo as u, useCallback as f } from "react";
import { DatePicker as p } from "../DatePicker/DatePicker.container.es.js";
const x = 100, F = ({
  isRequired: l = !1,
  label: D = "Date of birth",
  minAge: a,
  name: i = "birthday",
  onChange: s,
  inputProps: m,
  ...Y
}) => {
  const e = u(() => /* @__PURE__ */ new Date(), []), n = e.getFullYear(), o = u(() => {
    if (!a)
      return;
    const t = /* @__PURE__ */ new Date();
    return t.setFullYear(t.getFullYear() - a, t.getMonth(), t.getDate()), t;
  }, [a]), d = f(
    ({ dates: t }) => {
      const [r] = t;
      let c = "";
      return l && !r && (c = "Birthday is required"), o && r && r > o && (c = `Age must be less than ${a} years`), r && r > e && (c = "Date is in the future"), {
        [i]: c
      };
    },
    [o, e, l, i]
  ), h = f(
    (t) => {
      s == null || s(t);
    },
    [l, o, e, s]
  );
  return /* @__PURE__ */ b(
    p,
    {
      closeOnSelect: !0,
      label: D,
      max: e,
      maxYears: n,
      minYears: n - x,
      mode: "single",
      name: i,
      onChange: h,
      validate: d,
      inputProps: m,
      ...Y
    }
  );
};
export {
  F as BirthdayPicker
};
//# sourceMappingURL=BirthdayPicker.es.js.map
